export default "https://legacy.eskolare-development.com/images/contracts-empty.png";